module.exports = __webpack_public_path__ + "static/media/video-05.cf2821d8.mp4";